import React from 'react';
import * as styles from './features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Features = _ref => {
  var _ref$features = _ref.features,
    features = _ref$features === void 0 ? [] : _ref$features;
  return features.length ? ___EmotionJSX("section", null, ___EmotionJSX("div", {
    css: styles.heading
  }, "Features"), ___EmotionJSX("ul", {
    css: styles.list
  }, features.map(feature => ___EmotionJSX("li", {
    css: styles.listItem,
    key: feature
  }, feature)))) : ___EmotionJSX("noscript", null);
};